import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import PortalModal from 'components/Shared/PortalModal'
import { SecondaryButton, TransparentBgButton } from 'components/Shared/Button'

export default function GoogleTestCampaignAutoPromptModal({ isOpen, onClose, onAccept }) {
  const { t } = useTranslation()

  return (
    <PortalModal isOpen={isOpen} onClickOutside={onClose}>
      <div className="test-campaigns_auto-prompt yes-no-prompt">
        <div className="yes-no-prompt_content">
          <h1>
            {t('Settings.GoogleAccess.TestCampaign.autoPrompt.title', 'Run a Test Campaign?')}
          </h1>
          <p className="test-campaigns_auto-prompt_message">
            {t(
              'Settings.GoogleAccess.TestCampaign.autoPrompt.message',
              'Would you like to run a test Display campaign with your newly connected Google Ads account?',
            )}
          </p>
          <div className="my-4 text-left">
            <strong>
              {t(
                'Settings.GoogleAccess.TestCampaign.autoPrompt.whatYouWillDo',
                'What you will do:',
              )}
            </strong>
            <ul style={{ listStyleType: 'disc' }} className="mt-2 ml-3">
              <li>
                {t(
                  'Settings.GoogleAccess.TestCampaign.autoPrompt.step1',
                  'Select your Google Ads account',
                )}
              </li>
              <li>
                {t(
                  'Settings.GoogleAccess.TestCampaign.autoPrompt.step2',
                  'Optionally add a conversion action to test tracking',
                )}
              </li>
              <li>
                {t(
                  'Settings.GoogleAccess.TestCampaign.autoPrompt.step3',
                  'Publish a paused test Display campaign',
                )}
              </li>
            </ul>
          </div>
        </div>

        <div className="yes-no-prompt_footer w-100">
          <TransparentBgButton
            text={t('Settings.GoogleAccess.TestCampaign.autoPrompt.notNow', 'Not Now')}
            onClick={onClose}
            color="navy"
            extraStyles={{ flex: 1 }}
          />
          <SecondaryButton
            className="bt"
            text={t('Settings.GoogleAccess.TestCampaign.autoPrompt.yesRun', 'Yes, Run Test')}
            onClick={onAccept}
            extraStyles={{ flex: 1 }}
          />
        </div>
      </div>
    </PortalModal>
  )
}

GoogleTestCampaignAutoPromptModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired,
}
